import React from 'react';
import { API } from 'aws-amplify';
import { t } from 'i18next';
import { toast } from 'react-toastify';

import reducer from './reducer';

const useAssociatedApplicants = (userId) => {
    const [associatedApplicants, dispatch] = React.useReducer(reducer, {
        sortField: 'Unique ID',
        sortDir: 'Asc',
        hasMore: true,
        isFetching: true,
        recOffset: 0,
    });

    const handleAjaxError = () => {
        toast.error(t('General.AjaxError'));
        dispatch({ type: 'errored' });
    };

    const retrieveAssociatedApplicants = async () => {
        try {
            let _applicants = await API.post('ShipyardAPI', `/usersettings/${userId}/retrieve_associations`, {
                body: {
                    Sort: `\`${associatedApplicants.sortField}\` ${associatedApplicants.sortDir}`,
                    RecOffset: 0,
                },
            });

            dispatch({ type: 'retrieved', payload: _applicants });
        } catch (e) {
            handleAjaxError();
        }
    };

    const sortAssociatedApplicants = async (clicked) => {
        if (clicked === associatedApplicants.sortField) {
            let newSortDir = associatedApplicants.sortDir === 'Asc' ? 'Desc' : 'Asc';

            dispatch({ type: 'sort', newState: { sortDir: newSortDir } });

            try {
                let _applicants = await API.post('ShipyardAPI', `/usersettings/${userId}/retrieve_associations`, {
                    body: {
                        Sort: `\`${associatedApplicants.sortField}\` ${newSortDir}`,
                        RecOffset: 0,
                    },
                });

                dispatch({ type: 'sorted', list: _applicants?.associations instanceof Array ? _applicants.associations : [] });
            } catch (e) {
                handleAjaxError();
            }
        } else {
            dispatch({ type: 'sort', newState: { sortDir: 'Asc', sortField: clicked } });

            try {
                let _applicants = await API.post('ShipyardAPI', `/usersettings/${userId}/retrieve_associations`, {
                    body: {
                        Sort: `\`${clicked}\` Asc`,
                        RecOffset: 0,
                    },
                });

                dispatch({ type: 'sorted', list: _applicants?.associations instanceof Array ? _applicants.associations : [] });
            } catch (e) {
                handleAjaxError();
            }
        }
    };

    const loadMore = async () => {
        dispatch({ type: 'fetching' });
        try {
            let _applicants = await API.post('ShipyardAPI', `/usersettings/${userId}/retrieve_associations`, {
                body: {
                    Sort: `\`${associatedApplicants.sortField}\` ${associatedApplicants.sortDir}`,
                    RecOffset: associatedApplicants.recOffset,
                },
            });

            dispatch({ type: 'append', list: _applicants?.associations instanceof Array ? _applicants.associations : [] });
        } catch (e) {
            handleAjaxError();
        }
    };

    return { associatedApplicants, retrieveAssociatedApplicants, sortAssociatedApplicants, loadMore };
};

export default useAssociatedApplicants;
